import { render, staticRenderFns } from "./sprite.vue?vue&type=template&id=47d3edce&"
import script from "./sprite.vue?vue&type=script&lang=js&"
export * from "./sprite.vue?vue&type=script&lang=js&"
import style0 from "./sprite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports